export const WIDGET_GET_TOTAL_KITS = 'widget-get-total-kits';
export const WIDGET_GET_TOTAL_KITS_RESULT = `${WIDGET_GET_TOTAL_KITS}/result`;
export const WIDGET_GET_TOTAL_KITS_ERROR = `${WIDGET_GET_TOTAL_KITS}/error`;
